import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { PaginatedSearchParams } from '@src/types/Archivist';

interface UsePaginatedSearchProps {
  params: PaginatedSearchParams;
  options?: {
    enabled?: boolean;
    queryKeys?: string[];
  };
}

export default ({ params, options }: UsePaginatedSearchProps) => {
  const formattedParams = {
    page: params.page || 1,
    page_size: params.page_size || 25,
    ...(params.search && { search: params.search.toString() }),
    ...(params.specify && { specify: params.specify.toString() }),
    ...(params.filters && { filters: params.filters }),
  };

  return useApiQuery({
    queryKey: options?.queryKeys || [QueryKeys['get-pagination']],
    apiPath: '/get-pagination',
    method: 'POST',
    body: formattedParams,
    enabled: options?.enabled,
    useArchivistAPI: true,
  });
};
